export { default } from './Summary'

export const SummaryMapConfig = {}
